import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 37,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-cta-hover via-cta to-cta-hover bg-[length:200%_auto] animate-[shimmer_3s_linear_infinite] text-white py-2.5 px-4 text-center text-sm md:text-base font-bold shadow-lg" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-17">
        <span className="flex items-center gap-2" data-id="element-18">
          <span className="animate-pulse text-lg" data-id="element-19">⚡</span>
          ÚLTIMAS HORAS — Esta oferta se cierra pronto.
        </span>
        <div className="flex items-center gap-1.5 bg-black/20 px-3 py-0.5 rounded-full font-mono tracking-wider" data-id="element-20">
          <span data-id="element-21">{formatTime(timeLeft.hours)}</span>:
          <span data-id="element-22">{formatTime(timeLeft.minutes)}</span>:
          <span data-id="element-23">{formatTime(timeLeft.seconds)}</span>
        </div>
      </motion.div>
    </div>;
}